import { Route, Routes } from "react-router-dom";
import DirectoryArchiveFiles from "../child_components/DirectoryArchiveFiles";
import DirectoryDashboard from "../child_components/DirectoryDashboard";
import DirectoryFaqs from "../child_components/DirectoryFaqs";
import DirectoryFinetune from "../child_components/DirectoryFinetune";
import DirectoryUpload from "../child_components/DirectoryUpload";
import DirectoryFiles from "../child_components/DirectoryFiles";


function DirectoryManagement() {

    return(
        <div>
            <Routes>
                <Route path='/dashboard' element={ <DirectoryDashboard /> } />
                <Route path='/upload' element={ <DirectoryUpload /> } />
                <Route path='/files' element={ <DirectoryFiles /> } />
                <Route path='/archive_files' element={ <DirectoryArchiveFiles /> } />
                {/* <Route path='/faqs' element={ <DirectoryFaqs /> } />
                <Route path='/fine_tune' element={ <DirectoryFinetune /> } /> */}
            </Routes>
        </div>
    )
}

export default DirectoryManagement;